import { formatMoney } from 'client/griffin'
import { INSTRUMENT_EVENTS, INSTRUMENT_TAGS } from 'shared/shared_consts'

export const ANALYTICS_TYPES = {
  TRACK_CLICK: 'analytics/track_click',
  TRACK_IMPRESSION: 'analytics/track_impression',
}

const noop = () => {}
let PAYPAL = window.PAYPAL
let emptyAnalytics = { recordClick: noop, recordImpression: noop }
let analytics =
  PAYPAL && PAYPAL.analytics ? new PAYPAL.analytics.Analytics() : emptyAnalytics

export function initialize() {
  if (window.PAYPAL && window.PAYPAL.analytics) {
    window.PAYPAL.analytics.setupComplete = paypalAnalyticsSetupCompleted
    // call it anyway,
    // in case there's a weird race condition where `setupComplete` is already called from the analytics lib
    // before this was loaded.
    paypalAnalyticsSetupCompleted()
  }
}

export function paypalAnalyticsSetupCompleted() {
  if (_initialized) return // don't init twice
  if (!window.PAYPAL.analytics.instance) return // don't init if the analytic lib doesn't have a an instance yet

  _initialized = true
  _flushQueue()
}

export function trackImpression(payload) {
  track(ANALYTICS_TYPES.TRACK_IMPRESSION, payload)
}

export function trackEventNameClick(payload) {
  const {
    event_name,
    charity_name,
    npid,
    flow,
    campaignId,
    dismiss_method,
  } = payload
  trackClick({
    clickName: event_name,
    data: {
      event_name: event_name,
      product: INSTRUMENT_EVENTS.DW_GIVING,
      charityname: charity_name,
      crid: npid,
      flow: flow,
      campaign_id: campaignId,
      dismiss_method: dismiss_method,
    },
  })
}

export function trackClick(payload) {
  if (!payload.data) {
    return
  }
  payload.data.flow =
    payload.data.flow ||
    (payload.data.charityname
      ? 'GENEROSITY_NETWORK_CHARITIES'
      : 'GENEROSITY_NETWORK')
  track(ANALYTICS_TYPES.TRACK_CLICK, payload)
}

export function track(type, payload) {
  if (_initialized) {
    switch (type) {
      case ANALYTICS_TYPES.TRACK_CLICK:
        _trackClick(payload)
        break
      case ANALYTICS_TYPES.TRACK_IMPRESSION:
        _trackImpression(payload)
        break
      default:
        break
    }
  } else {
    _enqueueEvent(type, payload)
  }
}

let _initialized = false

// This queue is here to prevent a race condition.
// Since an analytics event can fire before the analytics client-side script
// has been initialized, we're queuing the events that fired while it's initializing,
// and fire all of them sequentially once initialization has completed.
let _q = []

function _flushQueue() {
  while (_q.length) {
    const ev = _q.shift()
    track(ev.type, ev.payload)
  }
}

function _enqueueEvent(type, payload) {
  _q.push({ type, payload })
}

function _trackClick({ clickName, data = {} }) {
  if (clickName) {
    let fpti = {
      data: {
        ...window.fpti,
        ...data,
      },
    }

    fpti.data.pgln = `${window.fpti.page}|${clickName}`
    fpti.data.pglk = `${window.fpti.pgrp}|${clickName}`
    fpti.data.link = clickName

    // actually record the click
    analytics.recordClick(fpti)

    // remove those additional keys for subsequent calls
    Object.keys(data).forEach(key => {
      delete window.fpti[key]
    })
  }
}

function _trackImpression({
  pageName,
  campaignId = '',
  flow = '',
  poolOwner = '',
  erpg = '',
  eccd = '',
  contingency = '',
  amount = '',
  currency = '',
  event_name = '',
  charityname = '',
  charity_name = '',
  npid = '',
  crid = '',
  error_code = '',
  screen = '',
  error_desc = '',
  event_type = '',
}) {
  pageName = `main:pools:${pageName}`

  window.fpti.page = pageName + ':::'
  window.fpti.pgrp = pageName
  window.fpti.link = undefined
  window.fpti.cmpn_id = campaignId
  window.fpti.encr_rcvr_id = poolOwner
  window.fpti.erpg = erpg
  window.fpti.eccd = eccd
  window.fpti.flow = flow || window.fpti.flow
  window.fpti.contingency = contingency
  window.fpti.event_name = event_name
  window.fpti.charityname =
    charityname || charity_name || window.fpti.charityname
  window.fpti.crid = crid || npid || window.fpti.crid
  window.fpti.product = INSTRUMENT_EVENTS.DW_GIVING
  window.fpti.platform = INSTRUMENT_TAGS.WEB
  window.fpti.pool_id = campaignId
  window.fpti.campaign_id = campaignId
  window.fpti.error_code = error_code
  window.fpti.screen = screen
  window.fpti.error_desc = error_desc
  window.fpti.event_type = event_type

  if (amount && currency) {
    let txn_amt = formatMoney(currency, amount, { removeTrailingZeros: false })
    window.fpti.txn_amt = `${txn_amt} ${currency}`
  }
  window.PAYPAL.analytics.instance.recordImpression()
}
